import { Translator } from 'Translator';
import memoize from 'lodash.memoize';

export enum SortType {
  DEFAULT = 'default',
  POPULATITY = 'popularity',
  PRICE_DESC = 'priceDesc',
  PRICE_ASC = 'priceAsc',
  RATING = 'rating',
  ALPHABETICAL = 'alphabetical',
}

export const SORT_OPTIONS = [
  {
    type: SortType.DEFAULT,
    label: Translator.translateText(
      'SearchPage.sorting.default',
      {},
      'Default',
    ),
  },
  {
    type: SortType.POPULATITY,
    label: Translator.translateText(
      'SearchPage.sorting.popularity',
      {},
      'Most popular',
    ),
  },
  {
    type: SortType.PRICE_DESC,
    label: Translator.translateText(
      'SearchPage.sorting.priceDesc',
      {},
      'Price: High-Low',
    ),
  },
  {
    type: SortType.PRICE_ASC,
    label: Translator.translateText(
      'SearchPage.sorting.priceAsc',
      {},
      'Price: Low-High',
    ),
  },
  {
    type: SortType.RATING,
    label: Translator.translateText(
      'SearchPage.sorting.rating',
      {},
      'Highest rating',
    ),
  },
  {
    type: SortType.ALPHABETICAL,
    label: Translator.translateText(
      'SearchPage.sorting.alphabetical',
      {},
      'Alphabetical order',
    ),
  },
];

export const typeToLabel = memoize((sortType: SortType) => {
  const option = SORT_OPTIONS.find(({ type }) => type === sortType);
  return option ? option.label : '<unknown>';
});

export const typeToParams = {
  [SortType.DEFAULT]: [],
  [SortType.POPULATITY]: [
    { name: 'sort', value: 'popularity' },
    { name: 'sortorder', value: 'desc' },
  ],
  [SortType.PRICE_DESC]: [
    { name: 'sort', value: 'price' },
    { name: 'sortorder', value: 'desc' },
  ],
  [SortType.PRICE_ASC]: [
    { name: 'sort', value: 'price' },
    { name: 'sortorder', value: 'asc' },
  ],
  [SortType.RATING]: [
    { name: 'sort', value: 'rating' },
    { name: 'sortorder', value: 'desc' },
  ],
  [SortType.ALPHABETICAL]: [
    { name: 'sort', value: 'alphabetical' },
    { name: 'sortorder', value: 'asc' },
  ],
};
